import dayjs from 'dayjs';
import { isNil } from 'lodash';

import { buildFormDeliveryDateWindow } from 'utils/date';

export const getInitialRecipientDatesById = (recipients = []) =>
  recipients.reduce(
    (acc, { recipientRequestId, sentDate, eSignedDate }) => ({
      ...acc,
      [recipientRequestId]: {
        sentDate: sentDate ? dayjs(sentDate) : null,
        eSignedDate: eSignedDate ? dayjs(eSignedDate) : null,
      },
    }),
    {},
  );

export const getOriginallySignedRecipientIds = (recipients = []) =>
  recipients
    .filter(({ eSignedDate }) => !!eSignedDate)
    .map(({ recipientRequestId }) => recipientRequestId);

const isSentBeforeOrSameDayAsESigned = (sentDate, eSignedDate) =>
  dayjs(sentDate).startOf('day').valueOf() <= dayjs(eSignedDate).startOf('day').valueOf();

const isRecipientDatesEntryValid = ({ sentDate, eSignedDate } = {}, wasSigned = false) => {
  if (!sentDate) {
    return false;
  }

  // FH-1435: the E-Signed date is optional — a null one records a sent-but-unsigned recipient. An
  // already-signed recipient must keep one, mirroring the backend's no-un-signing guard.
  if (isNil(eSignedDate)) {
    return !wasSigned;
  }

  return isSentBeforeOrSameDayAsESigned(sentDate, eSignedDate);
};

export const isAllRecipientDatesValid = (recipientDatesById, originallySignedIds = []) =>
  Object.entries(recipientDatesById).every(([recipientRequestId, entry]) =>
    isRecipientDatesEntryValid(entry, originallySignedIds.includes(recipientRequestId)),
  );

export const buildRecipientDatesPayload = recipientDatesById =>
  Object.entries(recipientDatesById).map(([recipientRequestId, { sentDate, eSignedDate }]) => ({
    recipientRequestId,
    ...buildFormDeliveryDateWindow(sentDate, eSignedDate),
  }));
